import { render } from "./CardServices.vue?vue&type=template&id=513b3356&scoped=true"
import script from "./CardServices.vue?vue&type=script&lang=js"
export * from "./CardServices.vue?vue&type=script&lang=js"

import "./CardServices.vue?vue&type=style&index=0&id=513b3356&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513b3356"]])

export default __exports__